<template>
    <div>
        <Headers :windowWidth="windowWidth" />
        <div class="t1">{{(type == 4 || form.type == 4) ? 'New Company User' : 'New Agency User'}}</div>
        <div class="createAccount_wrap">
            <div class="title">{{(type == 4 || form.type == 4) ? 'Company Information' : 'Agency Information'}}</div>
            <el-form>

                <el-row type="flex" justify="center" v-if="type == 4 || form.type == 4">
                    <el-col :span="12">
                        <el-form-item label="Company Name">
                            <el-input v-model="form.companyName" placeholder="Company Name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="center" v-if="type == 4 || form.type == 4">
                    <el-col :span="12">
                        <el-form-item label="UEN">
                            <el-input v-model="form.uen" placeholder="UEN"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" v-if="type == 4 || form.type == 4">
                    <el-col :span="12">
                        <div class="h3">Contact Person(s) Details</div>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-form-item label="First Name">
                            <el-input v-model="form.firstName" placeholder="Enter First Name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-form-item label="Last Name">
                            <el-input v-model="form.lastName" placeholder="Enter Last Name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-form-item label="User Name">
                            <el-input v-model="form.username" placeholder="Enter User Name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-form-item label="Phone Number">
                            <el-input v-model="form.mobile" placeholder="Enter Phone Number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-form-item label="Email Address">
                            <el-input v-model="form.email" placeholder="Enter Email Address"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" v-if="type == 4 || form.type == 4">
                    <el-col :span="12">
                        <el-form-item label="Facility address">
                            <el-input v-model="form.facilityAddress" placeholder="Facility address"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center" v-if="type == 4 || form.type == 4">
                    <el-col :span="12">
                        <el-form-item label="Facility name">
                            <el-input v-model="form.facilityName" placeholder="Facility name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <div class="c_tl">User Role(s)</div>
                        <div>
                            <div class="ch_box">
                                <div>
                                    <div class="ch_t" >Agency</div>
                                    <el-radio-group v-model="form.agencyRoles" @change="changeAgency" text-color="#158869" fill="#158869">
                                        <el-radio :label="'A1 - View only'"></el-radio>
                                        <el-radio :label="'A2- View with admin rights'"></el-radio>
                                        <el-radio :label="'A3- View with approval rights'"></el-radio>
                                    </el-radio-group>
                                </div>
                                <div>
                                    <div class="ch_t mg_t_40">Company</div>
                                    <el-radio-group v-model="form.companyRoles" @change="changeCompany" text-color="#158869" fill="#158869">
                                        <el-radio :label="'C1- View only'"></el-radio>
                                        <el-radio :label="'C2- View with admin rights'"></el-radio>
                                        <el-radio :label="'C3- View with approval rights'"></el-radio>
                                    </el-radio-group>
                                </div>
                                
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12">
                        <el-form-item label="Password">
                            <el-input v-model="form.password"></el-input>
                            <div class="flex_i">
                                <div class="l">*</div>
                                <div class="r">Password length must be between 8 and 12 characters, must contain at least 1 uppercase, 1 lowercase, 1 numeric, and no spaces.</div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="center">
                    <el-col :span="12" class="flex_btn">
                        <el-button class="save back" @click="back">{{$t('createAccount.Back')}}</el-button>
                        <el-button class="save" @click="save">{{$t('createAccount.save')}}</el-button>
                    </el-col>
                </el-row>

            </el-form>

            
            
        </div>
    </div>
</template>
<script>
import Headers from "@/components/header/index.vue";
import carbon from "@/api/carbon.js";
export default {
    components: { Headers },
    data(){
        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            status:false,
            checkList: [],
            type:null,
            form:{
                companyName:'',
                uen:'',
                firstName:'',
                lastName:'',
                username:'',
                mobile:'',
                email:'',
                facilityAddress:'',
                facilityName:'',
                agencyRoles:'',
                companyRoles:'',
                password:'',
                type:"",
                createUserId:'',
            }
        }
    },
    mounted() {
        let id = this.$route.query.id
        if(id){
            this.getuserinfo()
        }else{
            this.type = this.$route.query.type
            this.form.type = this.type
            this.form.createUserId = JSON.parse(sessionStorage.getItem('login')).id
        }
        
        let that = this;
        window.onresize = () => {
        return (() => {
            window.fullWidth = document.documentElement.clientWidth;
            (that.windowWidth = document.documentElement.clientWidth), //实时屏幕宽度
            (that.windowHeight = window.fullHeight); // 高
        })();
        };
    },
    methods:{
        save(){
            this.getcreateOrUpdate()
        },
        getcreateOrUpdate(){
            carbon.getcreateOrUpdate((res) => {
                if(res.code == 200){
                    if(this.$route.query.id){
                        this.$router.push({
                            path:'/accountDetail',
                            query:{
                                id:this.$route.query.id
                            },
                        })
                    }else{
                        this.$router.push('/security')
                    }
                }
            },this.form);
        },
        getuserinfo(){
            let params = {
                id:this.$route.query.id,
            }
            carbon.getuserinfo((res) => {
                if(res.code == 200){
                    this.form = res.data
                    // if(this.form.type == 4){
                    //     this.form.companyRoles = this.form.companyRoles.split(',')
                    // }else if(this.form.type == 5){
                    //     this.form.agencyRoles = this.form.agencyRoles.split(',')
                    // }
                }
            },params);
        },
        back(){
            this.$router.go(-1)
        },
        changeAgency(){
            console.log(this.form.agencyRoles)
        },
        changeCompany(){
            console.log(this.form.companyRoles)
        },
    }

}
</script>
<style lang="scss" scoped>
.t1{
    font-size: 40px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 45px;
    margin: 48px auto;
    width: 1534px;
}
.flex_i{
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: ArialMT;
    color: rgba(0,20,42,0.5);
    line-height: 20px;
    margin-top: 12px;
    .l{
        margin-right: 15px;
    }
    .r{
        text-align: justify;
    }
}
.createAccount_wrap{
    width: 1440px;
    background: #F8F9FA;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
    border-radius: 20px;
    padding: 74px 42px 105px 52px;
    .title{
        font-size: 40px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        text-align: center;
        color: #158869;
        line-height: 45px;
        margin-bottom: 50px;
    }
    .checkbox{
        height: 164px;
        background: #FFFFFF;
        border-radius: 4px;
        margin-top: 60px;
        padding: 20px;
    }
    .save{
        width: 125px;
        height: 44px;
        background: #158869;
        border-radius: 4px;
        font-size: 16px;
        font-family: ArialMT;
        color: #FFFFFF;
    }
    .back{
        background-color: #F8F9FA;
        border-color: #97A5B7;
        color: #97A5B7;
    }
}
.ch_box{
    padding: 32px 40px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 20px;
    .ch_t{
        font-size: 16px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #1E1E1E;
        line-height: 18px;
        margin-bottom: 12px;
    }
    .mg_t_40{
        margin-top: 40px;
    }
}
.flex_btn{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 80px;
}
.c_tl{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
.h3{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: rgba(30,30,30,0.8);
    line-height: 34px;
    margin: 90px 0 50px 0;
}
::v-deep .el-switch__label.is-active{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
::v-deep .el-switch__label{
    font-weight: bold;
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
}
::v-deep .el-form-item__label{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #21212B;
}
::v-deep .el-checkbox__label{
    font-size: 14px;
    font-family: ArialMT;
    color: #626262;
}
::v-deep .el-checkbox__inner{
    width: 20px;
    height: 20px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #158869;
    border-color:#158869;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #158869;
    font-size: 14px;
    font-family: ArialMT;
}
::v-deep .el-checkbox__inner::after{
    top: 17%;
    left: 42%;
}
</style>